import React from 'react';
import type { RelationshipValue } from '../../types';

// Phase 2 — relationship axis (four-axis lead status model, 2026-09-20).
export const RELATIONSHIP_COLORS: Record<RelationshipValue, { bg: string; fg: string }> = {
  prospect: { bg: '#f1f5f9', fg: '#64748b' }, // slate — default, no signal
  customer: { bg: '#dcfce7', fg: '#166534' }, // green
  churned:  { bg: '#fee2e2', fg: '#991b1b' }, // red
};

export const RELATIONSHIP_LABELS: Record<RelationshipValue, string> = {
  prospect: 'Prospect',
  customer: 'Customer',
  churned:  'Churned',
};

interface Props {
  relationship: RelationshipValue;
  compact?: boolean;
}

const RelationshipBadge: React.FC<Props> = ({ relationship, compact }) => {
  const c = RELATIONSHIP_COLORS[relationship] ?? RELATIONSHIP_COLORS.prospect;
  const label = RELATIONSHIP_LABELS[relationship] ?? relationship;

  const style: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    background: c.bg,
    color: c.fg,
    borderRadius: 999,
    padding: compact ? '2px 8px' : '4px 12px',
    fontSize: compact ? 11 : 12,
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: 0.2,
    userSelect: 'none',
  };

  return <span style={style} title={`Relationship: ${label}`}>{label}</span>;
};

export default RelationshipBadge;
